export enum Constants {
  APP_NAME = 'Dashboard Account Manager',
}
